import styles from "./NavBurger.module.css";
import {motion} from "framer-motion";

import {useState} from "react";


const NavBurgerMenu = () => {
    const [toggle, setToggle] = useState(false)
    const onDropDownMenu = () => {
        setToggle(!toggle)
    }

    return (
        <>
            <div className={styles.navBurger} onClick={onDropDownMenu}>
                <span className={`${styles.burger} w-5`}></span>
                <span className={`${styles.burger} w-8`}></span>
                <span className={`${styles.burger} w-10`}></span>
            </div>
            <motion.div
                className={`${styles.dropMenu}`}
                initial={{
                    top: '-100%',
                }}
                animate={{
                    top: toggle ? 0 : '-100%',
              }}

                transition={{
                    duration: 0.3,
                    type: 'tween',
                    ease: 'easeInOut'
                }}
            >
                <a onClick={onDropDownMenu} href='#home' className={styles.links} data-text="HOME">Home</a>
                <a onClick={onDropDownMenu} href='#about' className={styles.links} data-text="ABOUT">About</a>
                <a onClick={onDropDownMenu} href='#resume' className={styles.links} data-text="RESUME">Resume</a>
                <a onClick={onDropDownMenu} href='#skills' className={styles.links} data-text="SKILLS">Skills</a>
                <a onClick={onDropDownMenu} href='#portfolio' className={styles.links}
                   data-text="PORTFOLIO">Portfolio</a>
                <a onClick={onDropDownMenu} href='#contact' className={styles.links} data-text="CONTACT">Contact</a>
            </motion.div>
        </>
    )
}

export default NavBurgerMenu